const pouchCraftHoverMediaQuery = window.matchMedia(
  '(hover: hover) and (pointer: fine)'
);

document.addEventListener('pointerover', (event) => {
  if (!pouchCraftHoverMediaQuery.matches) return;

  const figure = event.target.closest('.product-card__figure');
  if (!figure) return;

  // Ignore movement between elements inside the same product image area
  if (event.relatedTarget && figure.contains(event.relatedTarget)) return;

  const video = figure.querySelector('.product-card__hover-video');
  if (!video) return;

  video.currentTime = 0;

  const playPromise = video.play();

  if (playPromise !== undefined) {
    playPromise.catch(() => {});
  }
});

document.addEventListener('pointerout', (event) => {
  if (!pouchCraftHoverMediaQuery.matches) return;

  const figure = event.target.closest('.product-card__figure');
  if (!figure) return;

  // Ignore movement between elements inside the same product image area
  if (event.relatedTarget && figure.contains(event.relatedTarget)) return;

  const video = figure.querySelector('.product-card__hover-video');
  if (!video) return;

  video.pause();
  video.currentTime = 0;
});